module.exports = __webpack_public_path__ + "img/UD.d72fb19e.png";